module.exports = __webpack_public_path__ + "img/edit-dent-red.8863e02c.svg";